import React, {Component} from 'react'
import SVG from 'react-inlinesvg'
import arrow from '@icons/arrow-right-white'
import {defaultSubjectPath} from '@app/components/ui/buttons/PlatformLink'
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Student} from '@app/models/users'
import {bindActionCreators} from "redux";
import * as studentActions from '@app/actions/students'

function is_enough_cards(tasks) {
  const statistic = solved(tasks)
  if (!statistic) {return false}

  const count = Object.values(statistic)
    .filter(value => value && value.answer && value.answer.score > 0
    ).length;

  return count == Object.values(statistic).length;
}

function solved(tasks) {
  let statistic = null
  if (tasks && tasks.trial && tasks.trial.objects) {statistic = tasks.trial.objects}

  return statistic
}

class BonusTaskOfTrialContainer extends Component {
  componentDidMount() {
    this.props.boundActions.fetchTasksIfNeeded(this.props.tour)
  }

  render() {
    if (window.COUNTRY !== 'IN') {return null}

    const { student, tour, tasks } = this.props
    if (!is_enough_cards(tasks)) {return null}

    let params = {
      redirect: 'recommended_card',
      utm_source: 'bricsmath',
      utm_medium: 'add_task',
      utm_campaign: 'eternal_link'
    }

    return (
      <div className="bonus-task">
        <div className="bonus-task__row">
          <div className="bonus-task__icon"></div>
          <p className="bonus-task__text">
            { I18n.t("students.bonus_task.text") }
          </p>
        </div>
        <div className="bonus-task__row">
          <a
            href={defaultSubjectPath()}
            target="_blank"
            className="btn btn--red btn--icon-right bonus-task__link">
            { I18n.t("js.students_table.solve") }
          </a>
        </div>
      </div>
    )
  }
}

BonusTaskOfTrialContainer.propTypes = {
  student: PropTypes.instanceOf(Student).isRequired,
  tour: PropTypes.string.isRequired,
  loader: PropTypes.bool.isRequired
}

BonusTaskOfTrialContainer.defaultProps = { loader: true }

const mapStateToProps = (state) => {
  const { students: { tasks } } = state;

  return { tasks }
}

const mapDispatchToProps = (dispatch) => {
  const boundActions = bindActionCreators(studentActions, dispatch)

  return { boundActions }
}

export default connect(mapStateToProps, mapDispatchToProps)(BonusTaskOfTrialContainer)
